import type { Theme } from '@mui/material';

export const styles = {
  shaping:
    (canDrop: boolean, isDummy: boolean, isOver: boolean) => (theme: Theme) => {
      const result = {
        maxWidth: '40%',
        padding: '0.5rem',
        borderRadius: '0.25rem',
        margin: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.colors.red[600],
      };

      if (canDrop) {
        Object.assign(result, { backgroundColor: theme.colors.red[400] });
        if (isOver) {
          Object.assign(result, { backgroundColor: theme.colors.green[500] });
        }
      }
      if (isDummy && (!isOver || !canDrop)) {
        Object.assign(result, {
          backgroundColor: theme.colors.red[100],
          color: theme.colors.black,
        });
      }
      return result;
    },

  buttonWrapper: (canDrop: boolean, isOver: boolean) => (theme: Theme) => {
    const result = {
      height: '100%',
      ml: 2,
      borderLeft: `1px solid ${theme.colors.red[700]}`,
      justifyContent: 'center',
    };

    if (canDrop) {
      Object.assign(result, { borderColor: theme.colors.red[600] });
      if (isOver) {
        Object.assign(result, { borderColor: theme.colors.green[600] });
      }
    }
    return result;
  },

  button: (theme: Theme) => ({
    py: 0,
    pr: 0,
    pl: '0.25rem',
    minWidth: '1.5rem',
    width: '1.5rem',
    minHeight: '100%',
    color: theme.colors.white,
  }),
};
